import React, {useState} from "react";

import "./TopicAreaCapture.css";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {LeftLabelTextInput} from "../../../common/input/left-label-text-input/LeftLabelTextInput";
import {LeftLabelToggle} from "../../../common/input/left-label-toggle/LeftLabelToggle";
import {createTopicArea, updateTopicArea} from "../../../../services/TopicAreaService";

export const TopicAreaCapture = ({context, navigateTo, navigateBack, showToaster, setSpinnerText}) => {
    const [externalReference] = useState(context.selectedTopicArea ? context.selectedTopicArea.externalReference : null);
    const [topicArea, setTopicArea] = useState(context.selectedTopicArea ? context.selectedTopicArea.topicArea : null);
    const [active, setActive] = useState(context.selectedTopicArea ? context.selectedTopicArea.active : false);

    const handleClick = async () => {
        const topicAreaToBeSaved = {
            externalReference,
            topicArea,
            active,
        }
        if (null === externalReference) {
            setSpinnerText("Creating Topic Area");
            const response = await createTopicArea(context.username, topicAreaToBeSaved);
            handleResponse(response);
        } else {
            setSpinnerText("Updating Topic Area");
            const response = await updateTopicArea(context.username, topicAreaToBeSaved);
            handleResponse(response);
        }
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                navigateTo("topicAreaTable");
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    return (
        <div className="topic-area-capture-container">
            <div className="topic-area-capture-form-container">
                <LeftLabelTextInput labelText="Topic Area:" defaultValue={topicArea} handleChange={({target}) => {
                    setTopicArea(target.value)
                }}/>
                <LeftLabelToggle labelText="Active: " active={active} setActive={setActive}/>
            </div>
            <div className="topic-area-capture-button-container">
                <StandardButton text={context.selectedTopicArea ? "Update Topic Area" : "Add Topic Area"}
                                onClick={handleClick}/>
                <StandardButton text="Back" onClick={navigateBack}/>
            </div>
        </div>
    );
}
